import { PureComponent } from 'react';

import ContentCard from '@opendoor/bricks/deprecated/UNSAFE_layout/ContentCard';

import { IGetReferralDashboardData } from '../graphql/queries/GetReferrralDashboardData';
import styles from '../styles/ReferCustomersSectionStyle.less';
import { ContentWrapper } from './ContentWrapper';
import ReferralLink from './ReferralLink';

class ReferCustomersSection extends PureComponent<IGetReferralDashboardData> {
  public render() {
    const { organization } = this.props;

    return (
      <ContentWrapper>
        <ContentCard title="Refer Customers To Opendoor" borderRadius="roundedSquare">
          <div className={styles.description}>
            Share this link with buyers who have a home to sell. Once they request an offer from
            Opendoor with this link, you can follow their progress below.
          </div>
          <div className={`${styles['referral-link']} large-margin-top medium-margin-bottom`}>
            <ReferralLink url={organization?.referralUrl as string} />
          </div>
        </ContentCard>
      </ContentWrapper>
    );
  }
}

export default ReferCustomersSection;
